import { AppRoutes } from '@constants/app-routes'
import { theme } from '@theme'
import { Link } from '@ui/links/Link'

export const config = {
  titleTitleSection: 'digital\ntransformation\nof education\ncompany',
  headerImagePath: '/images/digital-transformation-mac.webp',
  headerImageAlt: 'Education online platform',
  headerImageTitle: 'Education online platform',
  technologies: [
    {
      id: 'Challenge',
      title: 'Challenge',
      subtitle:
        'Build independent platforms for education, sales, and content distribution.',
      alt: '',
    },
    {
      id: 'Solution',
      title: 'Solution',
      subtitle: 'Create a big team of Front-end and Back-end developers.',
      alt: '',
    },
    {
      id: 'Tech stack',
      title: 'Tech stack',
      subtitle: (
        <>
          <Link href={AppRoutes.nodejs} target="blank">
            NodeJS
          </Link>
          , Express, Docker, MongoDB, GraphQL,{' '}
          <Link href={AppRoutes.reactNative} target="blank">
            React Native
          </Link>
          , Jest, Redis.
        </>
      ),
      alt: '',
      mobileFont: 2,
    },
  ],
  titleClient: 'Client',
  subtitleClientSection:
    'A large North American company engaged in educational resources distribution. With years of experience under their belt, the client has been successful in supplying innovative smart products for learning and teaching. The business has acquired a wide cross-industry customer base.',
  titleChallengeSection: <span>Challenge:</span>,
  challengeSectionList: [
    {
      title:
        'The client faced the riveting challenge of building three independent platforms with the following functions:',
      value: [
        'Centralization of all the available educational material in one place. The users get access to the materials and use them as intended',
        'A service marketplace for offering services and educational materials',
        'An online education platform with all the necessary functionality that enables teachers and students to have lessons on it ',
      ],
    },
    {
      title:
        'Our client had an urgent need for quick staff augmentation for the incremental launching of the three platforms. The essential factors to execute the upcoming projects with upscale results were:',
      value: [
        'Providing specialists with industry-related experience for their seamless integration in product development',
        'Involving all the developers from Front-end and Back-end teams in the project',
        'High expertise of engineers and a possibility of integrating additional resources with neither downtime nor quality loss',
      ],
    },
  ],
  challengeImage: [
    {
      id: 'empty hexagon',
      imagePath: '/images/emptyHexagon.svg',
      alt: '',
      width: '211',
      height: '389',
      rightPosition: theme.spaces[0],
      topPosition: theme.spaces[4],
      mobilePosition: 'absolute',
    },
    {
      id: 'hexagon',
      imagePath: '/images/case-gray-half-hexagon.svg',
      alt: '',
      width: '177',
      height: '340',
      leftPosition: theme.spaces[0],
      bottomPosition: '-10',
      mobilePosition: 'absolute',
    },
  ],
  titleSolution: <span>Solution:</span>,
  solutionList: [
    {
      title: (
        <>
          Our team consists of a sufficient number of{' '}
          <Link target="blank" href={AppRoutes.scaleYourTeam}>
            experienced developers
          </Link>{' '}
          to meet the client’s needs, which was a vital factor in our agreement
          for cooperation.
          <br />
          <br />
          We gauged the project scale in no time, handpicked the most suitable
          team, and started the second week by drafting the project’s
          architecture.
          <br />
          <br />
          The process of bolstering the client’s team with our experts was as
          follows:
        </>
      ),
      value: [
        'Building a team of senior NodeJS, React Native developers',
        'A full-scale launch of the three projects in three weeks thanks to quick integration of the outstaffed professionals and their project-related experience',
        'Timely integration of the talent pool during project implementation without sacrificing quality',
        'Expert assessment and planning of the project development, which contributed to initial cost optimization',
        'Transparent process with close monitoring and control over team performance and its communication with the in-house team',
      ],
    },
  ],
  solutionImageDetail: [
    {
      id: 'online learning platform',
      imagePath: '/images/online-learning-platform.webp',
      alt: 'Online learning platform',
      imageTitle: 'Online learning platform',
      width: '500',
      height: '691',
      rightPosition: theme.spaces[0],
      bottomPosition: -theme.spaces[2],
      show: false,
      className: 'online-learning',
    },
  ],
  titleResult: <span>Result:</span>,
  resultList: [
    {
      title: (
        <>
          At the moment, the project is at the finish line, we're having
          discussions with the client over our further cooperation prospects
          regarding other business challenges.
          <br />
          <br />
          We managed to establish an efficient and{' '}
          <Link target="blank" href={AppRoutes.approach}>
            agile
          </Link>{' '}
          synergy with excellent results:
        </>
      ),
      value: [
        'Two platforms are fully launched in the market and we’re currently at the final stage of implementing the online education platform',
        'The project teams saw no changes, all the developers performed a quality work during the three projects with no turnover',
        'Reduced costs on each of the projects thanks to the developers’ expertise and constant recommendations on increasing the efficiency of product development',
      ],
    },
  ],
  resultImages: [
    {
      id: 'hexagon',
      imagePath: '/images/case-half-gray-image.svg',
      alt: '',
      width: '381',
      height: '364',
      rightPosition: theme.spaces[0],
      bottomPosition: theme.spaces[0],
      show: false,
    },
  ],
}
